import { useMutation } from '@tanstack/react-query'
import { everyoneSocialSettings } from '../../v3/everyoneSocialSettings'
import {
  type EveryoneSocialSettings,
  type EveryoneSocialSettingsAttributes,
} from './types'

type UpdateParams = {
  id: EveryoneSocialSettings['id']
  attributes: EveryoneSocialSettingsAttributes
}

/**
 * Invalidate `globalQueryKeys.everyoneSocialSettings` in the call site's
 * `onSuccess`.
 */
export function useUpdateEveryoneSocialSettings() {
  return useMutation({
    mutationFn: ({ id, attributes }: UpdateParams) =>
      everyoneSocialSettings.update({
        params: { path: { everyone_social_settings_id: id } },
        requestBody: {
          data: { id, type: 'everyone_social_settings', attributes },
        },
      }),
  })
}
